import { createFileRoute } from "@tanstack/react-router";
import FirstTimeLogin from "@/components/auth/first-time-login";
import {
  AuthLeftPanel,
  AuthMobileLogo,
  AuthRightPanel,
} from "@/components/auth/auth-layout";

export const Route = createFileRoute("/_public/auth/first-time-login")({
  component: FirstTimeLoginPage,
});

function FirstTimeLoginPage() {
  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <AuthLeftPanel
        headline="Configura tu cuenta y comienza a trabajar"
        subtitle="Solo necesitas verificar tu correo y crear una contraseña para acceder a todas las herramientas de Heskala Logistics."
        badge="Configura tu cuenta"
      />

      <AuthRightPanel>
        <AuthMobileLogo />
        <FirstTimeLogin provider="password" />
      </AuthRightPanel>
    </div>
  );
}
